import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Config from 'config';
let config;
import { ERROR_CONSTANTS } from '../constants';
import metrics from '../lib/common/metrics';
import { toCurrency } from '../lib/common/displayHelpers';
import calculateTotal from '../lib/pricing/calculateTotal';
import ReactTooltip from 'react-tooltip';
import formattedDate from 'lib/common/formattedDate';
import displayTitle from 'lib/common/displayTitle';

import LineItem from './LineItem';
import { IconChevronDown, IconChevronUp, IconClose } from './Icons';
import isMobile from 'lib/common/isMobile';
import { get } from 'lodash';

class Basket extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    this.state = {
      activeTooltipId: false,
      tooltipDefaultContent: {},
      // Default to closed on small screens, open on large screens.
      isOpen:
        window.matchMedia && window.matchMedia('(min-width: 40em)').matches
          ? true
          : false,

      pinchAndZoomNotice: isMobile()
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.renderBasicNoticeMessage = this.renderBasicNoticeMessage.bind(this);

    this.showSeatTooltip = this.showSeatTooltip.bind(this);
    this.hideSeatTooltip = this.hideSeatTooltip.bind(this);

    this.handleRemoval = this.handleRemoval.bind(this);
    this.renderPinchAndZoomNotice = this.renderPinchAndZoomNotice.bind(this);
    this.handlePinchAndZoomNoticeClone = this.handlePinchAndZoomNoticeClone.bind(
      this
    );
  }

  handleToggle() {
    this.setState(
      prevState => {
        return {
          isOpen: !prevState.isOpen
        };
      },
      () => {
        metrics.action('Toggle cart', this.state.isOpen ? 'open' : 'close');
      }
    );
  }

  handleRemoval(item) {
    this.hideSeatTooltip(item);
    return this.props.handleRemoval(item);
  }

  renderBasicNoticeMessage() {
    const shouldRenderMessage =
      this.props.noticeMessage &&
      Object.keys(ERROR_CONSTANTS).indexOf(this.props.noticeMessage) == -1;

    if (shouldRenderMessage) {
      return (
        <div
          className="syos-basket__message"
          dangerouslySetInnerHTML={{ __html: this.props.noticeMessage }}
        />
      );
    } else {
      return null;
    }
  }

  renderPriceTypeMessage() {
    let priceTypeMessages = [];
    this.props.selectedSeats.map(item => {
      for (let priceTypeMessage of config.priceTypeMessages) {
        for (let priceTypesToCheck of priceTypeMessage.priceTypeIds) {
          if (
            priceTypesToCheck == item.priceData.price_type &&
            !priceTypeMessages.includes(priceTypeMessage.text)
          ) {
            priceTypeMessages.push(priceTypeMessage.text);
          }
        }
      }

      for (let zoneMessage of config.zoneMessages) {
        for (let zoneToCheck of zoneMessage.zoneIds) {
          if (
            zoneToCheck == item.priceData.zone_no &&
            !priceTypeMessages.includes(zoneMessage.text)
          ) {
            priceTypeMessages.push(zoneMessage.text);
          }
        }
      }
    });

    if (priceTypeMessages.length > 0) {
      return (
        <ul className="syos-basket__price-messages">
          {priceTypeMessages.map(priceMessage => {
            return (
              <li className="syos-basket__price-message" key={priceMessage}>
                {priceMessage}
              </li>
            );
          })}
        </ul>
      );
    } else {
      return null;
    }
  }

  showSeatTooltip(seatItem) {
    let seatSVG = seatItem.seatEl;
    if (seatItem.customSeatEl) {
      seatSVG = seatItem.customSeatEl;
    }

    if (!seatSVG) {
      return;
    }

    if (!document.body.classList.contains('line-item-tooltip')) {
      document.body.classList.add('line-item-tooltip');
    }

    let itemId = seatItem.seatData.seat_no;
    let tooltipDefaultContent = this.state.tooltipDefaultContent;
    if (!tooltipDefaultContent[itemId]) {
      tooltipDefaultContent[itemId] = {
        dataTip: seatSVG.getAttribute('data-tip')
      };

      this.setState({
        tooltipDefaultContent: tooltipDefaultContent,
        activeTooltipId: itemId
      });
    } else {
      if (this.state.activeTooltipId !== itemId) {
        this.setState({
          activeTooltipId: itemId
        });
      }
    }

    let dataTip = `${seatItem.priceData.zone_desc} ${
      seatItem.seatData.seat_row
    }, ${seatItem.seatData.seat_num}`;

    seatSVG.setAttribute('data-tip', dataTip);

    ReactTooltip.show(seatSVG);
  }

  hideSeatTooltip(seatItem) {
    let seatSVG = seatItem.seatEl;
    if (seatItem.customSeatEl) {
      seatSVG = seatItem.customSeatEl;
    }

    if (document.body.classList.contains('line-item-tooltip')) {
      document.body.classList.remove('line-item-tooltip');
    }

    let tooltipDefaultContent = this.state.tooltipDefaultContent;
    let itemId = seatItem.seatData.seat_no;

    if (tooltipDefaultContent[itemId]) {
      seatSVG.setAttribute('data-tip', tooltipDefaultContent[itemId].dataTip);
    }

    ReactTooltip.hide(seatSVG);
  }

  handlePinchAndZoomNoticeClone() {
    this.setState({
      pinchAndZoomNotice: false
    });
  }

  renderPinchAndZoomNotice() {
    return this.state.pinchAndZoomNotice ? (
      <div className={`pinch-and-zoom-notice`}>
        Pinch to zoom.
        <button
          className="syos-modal__close"
          aria-label="Close"
          onClick={this.handlePinchAndZoomNoticeClone}
          tabIndex="0"
        >
          <IconClose />
        </button>
      </div>
    ) : null;
  }

  render() {
    const totalToDisplay = toCurrency(
      calculateTotal(this.props.selectedSeats.map(x => x.priceData.price))
    );

    const details = this.props.details;
    const webContent = get(details, 'webContent', []);

    return (
      <div
        className={classnames('syos-basket', {
          'syos-basket--closed': !this.state.isOpen
        })}
      >
        {this.renderBasicNoticeMessage()}
        {this.renderPinchAndZoomNotice()}
        <div className="syos-basket__inner">
          <h2
            dangerouslySetInnerHTML={{
              __html:
                details &&
                displayTitle(this.props.details.summary.description, webContent)
            }}
          />
          <p>
            {this.props.details.summary.facility_desc === 'WDCH'
              ? 'Walt Disney Concert Hall'
              : this.props.details.summary.facility_desc}
          </p>
          <p className="syos-performance-details__subtitle">
            {this.props.details.summary.perf_dt && (
              <span className="syos-performance-details__date">
                {formattedDate(this.props.details.summary.perf_dt)}
              </span>
            )}
          </p>
          <div className="syos-basket__header">
            <div className="syos-basket__details">
              <hr />
              <div className="syos-basket__toggle">
                <button
                  className="syos-basket__toggle u-syos-button-reset"
                  onClick={this.handleToggle}
                >
                  {this.state.isOpen ? <IconChevronDown /> : <IconChevronUp />}
                </button>
                <div className="syos-basket__total__container">
                  <span className="syos-basket__total">
                    <span className="syos-basket__total-label">
                      {`${config.basket.totalLabel}: `}
                    </span>
                    <span className="syos-basket__total-value">
                      {totalToDisplay}
                    </span>
                  </span>
                  <span
                    className={classnames({
                      'syos-basket__seats': true,
                      'syos-basket__seats--hidden':
                        this.props.selectedSeats.length === 0 || !isMobile()
                    })}
                  >
                    <span className="syos-basket__total-label">
                      {`${
                        this.props.selectedSeats.length === 1
                          ? config.basket.totalSeatSingularLabel
                          : config.basket.totalSeatPluralLabel
                      }: `}
                    </span>
                    <span className="syos-basket__total-value">
                      {this.props.selectedSeats.length}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="syos-basket__actions">
              <button
                tabIndex={1}
                className="syos-button"
                onClick={this.props.handleSubmit}
                disabled={this.props.isProcessing}
              >
                {this.props.buttonLabel}
              </button>
            </div>
          </div>
          <div className="syos-basket__contents">
            {this.renderPriceTypeMessage()}
            <div className="syos-basket__selections">
              <ul className="syos-basket__lineItems">
                {this.props.selectedSeats.map(item => {
                  return (
                    <li
                      key={item.seatData.seat_no}
                      id={`line-item-${item.seatData.seat_no}`}
                      onMouseEnter={() => this.showSeatTooltip(item)}
                      onMouseLeave={() => this.hideSeatTooltip(item)}
                      onMouseMove={() => this.showSeatTooltip(item)}
                    >
                      <LineItem
                        lineItem={item}
                        prices={this.props.prices}
                        onClickRemoval={() => this.handleRemoval(item)}
                        onClickReselect={() =>
                          this.props.handleReselection(item)
                        }
                        onChangeUpdatePrice={this.props.handlePriceTypeChange}
                        zoneNames={this.props.zoneNames}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Basket.propTypes = {
  selectedSeats: PropTypes.array,
  isProcessing: PropTypes.bool,
  prices: PropTypes.array,
  noticeMessage: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleRemoval: PropTypes.func.isRequired,
  handleReselection: PropTypes.func.isRequired,
  handlePriceTypeChange: PropTypes.func.isRequired,
  details: PropTypes.object,
  zoneNames: PropTypes.object
};

export default Basket;



// WEBPACK FOOTER //
// ./src/javascripts/components/Basket.js